import { FC, memo } from 'react';
import classNames from 'classnames';
import { FaCheckCircle } from 'react-icons/fa';

export interface TableFieldProps {
  isActive: boolean;
  isEmptyDay: boolean;
  onClick: () => void;
  text: string;
  isAllConsumed: boolean;
  startServeTime?: any;
  endServeTime?: any;
}

export const TableField: FC<TableFieldProps> = memo(({
  isActive,
  isEmptyDay,
  text,
  onClick,
  isAllConsumed,
}) => {

  const color = isAllConsumed ? '#ff9b36' : (isActive ? '#1d8922' : '#333');

  return (
    <div onClick={() => isActive && onClick()} style={{ opacity: isEmptyDay ? 0 : 1 }} className="flex justify-center items-center mx-1 cursor-pointer">
      {isActive && <FaCheckCircle style={{ width: '14px', minWidth: '14px' }} className="mx-2" color={color} />}
      <span
        style={{ color }}
        className={classNames('font-medium truncate')}>{text}</span>
    </div>
  );
});

export default TableField;
